<style>
.b-toast-danger .toast .toast-header {
  color: #721c24;
  background-color: rgba(248, 215, 218, .85);
  border-bottom-color: rgba(245, 198, 203, .85);
}

.b-toast-danger .toast {
  background-color: rgba(252, 237, 238, .85);
  border-color: rgba(245, 198, 203, .85);
  color: #721c24;
}

.b-toast-info .toast .toast-header {
  color: #1c2a72;
  background-color: rgba(215, 224, 248, 0.85);
  border-bottom-color: rgba(198, 217, 245, 0.85);
}

.b-toast-info .toast {
  background-color: rgba(237, 243, 252, 0.85);
  border-color: rgba(198, 212, 245, 0.85);
  color: #1c2372;
}

</style>
<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import Vue from 'vue'

import {deviceApi} from '@router/apiFiles/deviceApi'
import {customerApi} from '@router/apiFiles/customerApi'


export default {
  page: {
    title: 'Device search',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      tableData: [],
      isBusy: true,
      title: 'Device search',
      items: [
        {
          text: 'OnBoard',
          href: '/',
        },
        {
          text: 'Devices',
          href: '/',
        },
        {
          text: 'Device search',
          active: true,
        },
      ],
      filter: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      fields: [
        'link',
        {key: 'chassis', label: 'Chassis', sortable: false},
        {key: 'deviceModelName', label: 'Model', sortable: false},
        {key: 'lastConnection', label: 'Last Connection', sortable: false},
        {key: 'supplierPlanName', label: 'Plan', sortable: false},
        {key: 'customer', label: 'Customer', sortable: false},
        {key: 'groupName', label: 'Group', sortable: false},
        {key: 'options', label: 'Options', sortable: false},
      ],
      customerId: '',
      currentUser: null,
      showTableDeviceModels: false,
      listDeviceModels: [
        {name: 'CANLink Simplex', description: ''},
        {name: 'AnalogLink Simplex', description: ''},
        {name: 'CANLink Duplex', description: ''},
        {name: 'AnalogLink Duplex', description: ''},
        {name: 'OnLink Simplex', description: ''},
        {name: 'OnLink Duplex', description: ''},
        {name: 'TITAN-4G', description: ''},
      ],
      fieldsHistory: [
        {key: 'dateChange', label: 'Date', sortable: false},
        {key: 'modemIdentifier', label: 'Identifier', sortable: false},
        {key: 'userName', label: 'Modifier User', sortable: false},
        {key: 'assetIdentifier', label: 'Chassis', sortable: false},
        {key: 'customerName', label: 'Customer', sortable: false},
        {key: 'groupName', label: 'Group', sortable: false},
      ],
      isLoading: false,
      currentPageHistory: 1,
      totalRowsHistory: 0,
      historyData: [],
      currentDeviceId: '',
      deviceSelected:'',
      supplierPlanOptions:[],
      supplierPlanSelected: ''

    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  mounted() {
    const currentUserData = localStorage.getItem('auth.currentUser');
    this.searchSupplierPlan()
    if (currentUserData) {
      this.currentUser = JSON.parse(currentUserData);
    }
    this.getAllCustomers()
    this.fetchData().catch(error => {
      console.error(error)
    })
  },
  methods: {
    searchSupplierPlan(){
      deviceApi.searchSupplierPlan()
          .then(response => {
            this.supplierPlanOptions = response.data
            console.log('Planos: ', response.data)
          });
    },
    
    makeToast(msg, variant) {
      this.$bvToast.toast(msg, {
        title: `Info`,
        variant: variant,
        autoHideDelay: 2500,
        solid: false,
      })
    },
    async getAllCustomers() {
      var self = this;
      customerApi.searchCustomers({search: '', page: 1, perPage: 100})
          .then(function (data) {
            self.customers = data.data;
          });
    },


    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      //this.totalRows = filteredItems.length
      //this.currentPage = 1
      //console.log(filteredItems);
    },
    async fetchData() {
      var self = this;
      deviceApi.searchDevices({
        search: self.filter,
        page: self.currentPage,
        perPage: self.perPage,
        customerId: this.customerId,
        supplierPlanId: this.supplierPlanSelected
      })
          .then(function (data) {
            self.tableData = data.data;
            self.isBusy = false;
            self.totalRows = data.totalItems;
          });
    },
    
    async fetchHistory() {
      this.isLoading = true;

      deviceApi.searchHistory({deviceId: this.currentDeviceId, page: this.currentPageHistory})
          .then(data => {
            console.log(data.data)
            this.historyData = data.data;
            this.isLoading = false;
            this.totalRowsHistory = data.totalItems;
          })
          .catch(e => {
            this.makeToast('An unexpected error occurred', 'danger')
          })
          .finally(f => {
            this.isLoading = false;
          })
    },
    getReport() {
      this.isBusy = true;
      deviceApi.getDevicesReport({
            search: this.filter,
            customerId: this.customerId,
            supplierPlanId: this.supplierPlanSelected
          })
          .then(response => {
            this.isBusy = false;
          });
    },
    openHistory(deviceId) {
      this.historyData = []
      this.currentDeviceId = deviceId
      this.fetchHistory()
      this.$refs['my-modal'].show()
    },
    openRequest(id){
      this.$refs['modal-confirmation'].show()
      this.deviceSelected = id
    },
    closeModal(){
      this.$refs['modal-confirmation'].hide()
      this.deviceSelected = ''
    },
    createRequest(){
      this.$refs['modal-confirmation'].hide()
      
      deviceApi.createRequest({deviceId: this.deviceSelected})
          .then(data => {
            this.makeToast('Request created', 'info')
          })
          .catch(e => {
            this.makeToast('An unexpected error occurred', 'danger')
          })
          .finally(f => {
            this.deviceSelected = ''
          })
    }
    
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    currentPageHistory: {
      handler: function (value) {
        this.fetchHistory()
      }
    },
    perPage: {
      handler: function (value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row" v-if="false">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div role="tablist" class="custom-accordionwitharrow">
              <b-card no-body class="mb-1 border shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <a v-b-toggle.accordion-1 @click="showTableDeviceModels = !showTableDeviceModels"
                     href="javascript: void(0);"
                     class="text-black d-flex justify-content-between align-items-center">
                    <h5 class="h5 m-0 font-size-16">Device Models Captions</h5>
                    <feather v-if="!showTableDeviceModels" type="chevron-down"></feather>
                    <feather v-else type="chevron-up"></feather>
                  </a>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="table-responsive">
                      <table class="table table-bordered table-centered mb-0">
                        <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <th>Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listDeviceModels" :key="item.name">
                          <td scope="row"><strong>{{ item.name }}</strong></td>
                          <td>{{ item.description }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-4"></p>
            <div class="row mb-md-2">
              <div class="col-sm-12">
                <div id="tickets-table_length" class="dataTables_length  text-md-right float-right">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm"
                                   :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <div class="row mb-md-2">

              <!-- Search -->
              <div class="col-sm-5 col-md-4">
                <div>
                  <label class="">
                    Search:
                  </label>
                  <b-input-group>
                    <b-form-input v-model="filter" type="search" placeholder="modem Id, Chassis..."
                                  class="form-control form-control-sm"></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <!-- End search -->

              <!-- Customer -->
              <div v-if="currentUser && currentUser.role == '1'" class="col-sm-3 col-md-2">
                <div class="form-group">
                  <label>Customer</label>
                  <div>
                    <select class="form-control form-control-sm" v-model="customerId"
                            style="max-width:100%">
                      <option value=""></option>
                      <option v-for="customer of customers" v-bind:key="customer.id"
                              v-bind:value="customer.id">{{ customer.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- End Customer -->

              <!-- SupplierPlan -->
              <div v-if="currentUser && currentUser.role == '1'" class="col-sm-2 col-md-2">
                <div class="form-group">
                  <label>Plan</label>
                  <div>
                    <select class="form-control form-control-sm" v-model="supplierPlanSelected"
                            style="max-width:100%">
                      <option value=""></option>
                      <option v-for="plan of supplierPlanOptions" v-bind:key="plan.id"
                              v-bind:value="plan.id">{{ plan.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- End Customer -->

              <div class="col-sm-2 col-md-1">
                <div>
                  <div class="form-group form-group-sm">
                    <label>Find</label>
                    <div>
                      <button class="btn btn-sm btn-info" @click="fetchData"><i
                          class="uil uil-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-2 col-md-1" v-if="currentUser && currentUser.role == '1'">
                <div>
                  <div class="form-group form-group-sm">
                    <label>Export</label>
                    <div>
                      <button class="btn btn-sm btn-info" @click="getReport"><i class="uil uil-file-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table :items="tableData" :fields="fields" responsive="sm" :per-page="0"
                       :current-page="currentPage" :busy="isBusy">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(link)="data">
                  <div class="d-flex justify-content-between align-items-start flex-column flex-sm-row">
                    <router-link tag="a" target="_self" :to="`/device/${data.item.id}`"><b>{{
                        data.item.modemIdentifier
                      }}</b></router-link>
                    <router-link class="mt-3 mt-sm-0" tag="a" target="_blank" :to="`/device/${data.item.id}`"><b><i class="uil uil-external-link-alt "></i></b></router-link>
                    
                  </div>
                  
                </template>
                <!-- Column: Options -->
                <template #head(options)>
                  <div>Options</div>
                </template>
                <template #cell(options)="data">
                  <b-dropdown variant="link" no-caret dropleft>

                    <template #button-content>
                      <i class="uil uil-bars text-dark"/>
                    </template>

                    <b-dropdown-item target="_blank" :to="`/device/${data.item.id}`">
                      <i class="uil  uil-external-link-alt mr-1"/>
                      <span class="align-middle ">Show</span>
                    </b-dropdown-item>

                    <b-dropdown-item v-if="currentUser && currentUser.role == '1'" target="_blank" :to="`/devicetelemetryvalues/${data.item.id}`">
                      <i class="uil  uil-external-link-alt mr-1"/>
                      <span class="align-middle ">Last Telemetry</span>
                    </b-dropdown-item>

                    <b-dropdown-item @click="openHistory(data.item.id)">
                      <i class="uil uil-history mr-1"/>
                      <span class="align-middle ">History</span>
                    </b-dropdown-item>
                    
                    <b-dropdown-item @click="openRequest(data.item.id)">
                      <i class="uil  uil-shield-exclamation mr-1"/>
                      <span class="align-middle ">Request Deactivation</span>
                    </b-dropdown-item>
                    
                  </b-dropdown>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows"
                                  :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal ref="modal-confirmation" size="md" title="Deactivation of the plan" no-close-on-backdrop @hide="false"
               :hide-footer="true">
        <div class="text-center row">
          <div class="col-md-12">
            <h3>Are you sure you want to request deactivation of the plan?</h3>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <div class="row w-100">
            <div class="col-6 text-right">
              <a href="javascript: void(0);" @click="createRequest()" class="btn btn-primary">Ok</a>
            </div>
            <div class="col-6 text-left">
              <a href="javascript: void(0);" @click="closeModal()" class="btn btn-danger">Cancel</a>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal ref="my-modal" size="xl" title="History" no-close-on-backdrop @hide="false" scrollable
               :hide-footer="true">

        <!-- Table -->
        <div class="table-responsive mb-0">
          <b-table :items="historyData" :fields="fieldsHistory" responsive="sm" :per-page="0" show-empty
                   empty-text="No matching records found"
                   :current-page="currentPage" :busy="isLoading">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner variant="primary" class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPageHistory" :total-rows="totalRowsHistory" :per-page="15"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

  </Layout>
</template>
